











import { Vue, Component, Ref } from 'vue-property-decorator'
import paises from '@/shareds/tabelas/paises'

@Component
export default class SeletorDePais extends Vue {
	@Ref() wrapped!: Vue &
		HTMLInputElement &
		{ isMenuActive: boolean }
	paises = paises

	public focus() {
		this.wrapped.focus()
	}
}

